import React, { FunctionComponent, useEffect, useState } from 'react';
import { sharedUtilsGetLang } from '../../../../utils/lang-utils';
import { IntlProvider, MessageFormatElement } from 'react-intl';
import { API_ASSETS } from '../../../../services';
import CalculatorSquareMeterAverageCta from './components/calculator-square-meter-average-cta';
import CalculatorSquareMeterAverageSearch from './components/calculator-square-meter-average-search';
import { Spinner } from '@chakra-ui/react';

export const CalculatorSquareMeterAverage: FunctionComponent = () => {
  const [locale] = useState(sharedUtilsGetLang());
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [messages, setMessages] = useState<Record<string, MessageFormatElement[]>>(
    {} as Record<string, MessageFormatElement[]>
  );

  useEffect(() => {
    const loadData = async () => {
      const data: Record<string, MessageFormatElement[]> = await API_ASSETS.get(
        `calculators/square-meter-average/compiled-lang/${locale}.json`
      );
      setMessages(data);
      setIsLoading(false);
    };
    loadData();
  }, [locale]);

  return (
    <>
      {isLoading && (
        <div className={`my-8 text-center opacity-50`}>
          <Spinner size="md" />
        </div>
      )}

      {!isLoading && (
        <IntlProvider locale={locale} messages={messages} defaultLocale={'nl'}>
          <div className={`grid grid-rows-1 md:grid-cols-2 md:gap-20`}>
            <div className={`flex items-center`}>
              <CalculatorSquareMeterAverageCta />
            </div>
            <div className={`md:min-h-[500px]`}>
              <CalculatorSquareMeterAverageSearch />
            </div>
          </div>
        </IntlProvider>
      )}
    </>
  );
};

export default CalculatorSquareMeterAverage;
